const ANALYTICS_ROOT_PATHS = {
    PAYMENT: '/payment',
};

export default ANALYTICS_ROOT_PATHS;
